import { View, Text, Image } from '@react-pdf/renderer';

import { PDFKinematicGraphSection } from '@/components/PDFDownload/Components/PDFKinematicGraphSection';
import { PDFPage } from '@/components/PDFDownload/Components/PDFPage';
import { PDFSLSquatInfoTable } from '@/components/PDFDownload/Components/PDFSLSquatInfoTable';
import { PDFVersion } from '@/components/PDFDownload/PDFDocument';
import { PDFFormatting, PDFTextStyles } from '@/components/PDFDownload/styles';

import SingleLegSquatAvatar from '@/assets/avatars/squat/singleLegSquatAvatar.png';

export interface DocumentProps {
  reportInfo: any;
  data: any;
  version: PDFVersion;
  headerLogoURL: string;
  organizationName: string;
}

export const PDFSLSquatReport = ({ reportInfo, data, version, headerLogoURL, organizationName }: DocumentProps) => {
  const reportName = reportInfo.reportName;
  const logoUrl = headerLogoURL;
  return (
    <>
      {/* MObility Status & Analysis Cards */}
      <PDFPage PageNumber={1} logoUrl={logoUrl} organizationName={organizationName} reportName={reportName}>
        <Image src={SingleLegSquatAvatar} style={PDFFormatting.avatar} />
        <View style={PDFFormatting.contentContainer_65}>
          <View style={PDFFormatting.tableContainer}>
            <Text style={PDFTextStyles.containerTitle}>Info</Text>
            <PDFSLSquatInfoTable
              keyPerformanceIndicatorData={data.qualityData}
              labels={data.Labels}
              repetitionTimeData={data.repetitionData}
              romData={data.romData}
            />
          </View>
        </View>
      </PDFPage>

      {/* Kinematic Graphs */}
      {version === 'Specialist' && (
        <PDFPage PageNumber={2} logoUrl={logoUrl} organizationName={organizationName} reportName={reportName}>
          <PDFKinematicGraphSection
            coronalGraph={data.pelvisKinematicCoronalChartDataUri}
            sagittalGraph={data.pelvisKinematicSagittalChartDataUri}
            title={'Pelvis'}
            transversalGraph={data.pelvisKinematicTransversalChartDataUri}
          />
          <PDFKinematicGraphSection
            coronalGraph={data.hipKinematicCoronalChartDataUri}
            sagittalGraph={data.hipKinematicSagittalChartDataUri}
            title={'Hip'}
            transversalGraph={data.hipKinematicTransversalChartDataUri}
          />
          <PDFKinematicGraphSection
            coronalGraph={data.kneeKinematicCoronalChartDataUri}
            sagittalGraph={data.kneeKinematicSagittalChartDataUri}
            title={'Knee'}
            transversalGraph={data.kneeKinematicTransversalChartDataUri}
          />
          <PDFKinematicGraphSection
            coronalGraph={data.ankleKinematicCoronalChartDataUri}
            sagittalGraph={data.ankleKinematicSagittalChartDataUri}
            title={'Ankle'}
            transversalGraph={data.ankleKinematicTransversalChartDataUri}
          />
        </PDFPage>
      )}
    </>
  );
};
